import { IPrintableError } from '@/error/IPrintableError'

export default class ValidationError extends Error implements IPrintableError {
  constraints: Map<string, Array<string>>

  constructor(constraints: Map<string, Array<string>>) {
    super()
    this.name = 'ValidationError'
    this.constraints = constraints
  }

  getError(key: string): Array<string> | undefined {
    return this.constraints.get(key)
  }

  hasError(key: string): boolean {
    return this.constraints.has(key)
  }

  getPrintableErrors(): string[] {
    if (this.hasError('content')) {
      return this.getError('content') ?? []
    }

    return []
  }
}
